import { aboutContent } from '@/mocks/homeData';

export default function About() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">{aboutContent.title}</h2>
            <div className="w-16 h-1 bg-primary-500 mx-auto rounded-full"></div>
          </div>

          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            {aboutContent.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mt-8 md:mt-10 pt-8 border-t border-background-200">
            <div className="text-center p-4 rounded-lg bg-background-100">
              <div className="text-2xl md:text-3xl font-heading text-primary-500 mb-1">800万+</div>
              <p className="text-xs md:text-sm text-foreground-600">累计服务用户</p>
            </div>
            <div className="text-center p-4 rounded-lg bg-background-100">
              <div className="text-2xl md:text-3xl font-heading text-accent-500 mb-1">200条+</div>
              <p className="text-xs md:text-sm text-foreground-600">日均内容更新</p>
            </div>
            <div className="text-center p-4 rounded-lg bg-background-100">
              <div className="text-2xl md:text-3xl font-heading text-secondary-500 mb-1">300+</div>
              <p className="text-xs md:text-sm text-foreground-600">覆盖城市数量</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}